import { render } from "./NewsFeatures.vue?vue&type=template&id=5ef437cc&scoped=true"
import script from "./NewsFeatures.vue?vue&type=script&lang=js"
export * from "./NewsFeatures.vue?vue&type=script&lang=js"

import "./NewsFeatures.vue?vue&type=style&index=0&id=5ef437cc&scoped=true&lang=css"

import exportComponent from "../../.yarn/__virtual__/vue-loader-virtual-6763a87ef6/0/cache/vue-loader-npm-17.4.2-00674d01e5-ffbe3e848e.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef437cc"]])

export default __exports__